import { uniqWith } from 'ramda'

export function getSourceReferences(text: string): Array<{ type: string; id: string }> {
    const regexp =
        /\(?z:\/\/(.+?)\/([0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-4[0-9A-Fa-f]{3}-[89ABab][0-9A-Fa-f]{3}-[0-9A-Fa-f]{12}|[0-9]+).*?\)?/g
    const references = []
    let matches = []
    while ((matches = regexp.exec(text))) {
        references.push({ type: matches[1], id: matches[2] })
    }

    return uniqWith((a, b) => a.id === b.id && a.type === b.type, references)
}
